import { Injectable } from '@angular/core'
import { PvsRequestFactoryService } from './pvs-request-factory.service'
import { ApiPath } from '../../config/global-const'

@Injectable({
    providedIn: 'root',
})
export class UserAdminService {
    constructor(private requestService: PvsRequestFactoryService) {}

    public getAll(params = {}) {
        const p = {
            orderBy: 'id|desc',
            ...params,
        }
        const url = this.requestService.createUrl(ApiPath.ADMIN.USER_ADMIN.PATH)
        return this.requestService.requestGet(url, p)
    }
    public getInSalon(salonId: number, params = {}) {
        const p = {
            orderBy: 'id|desc',
            ...params,
        }
        const url = this.requestService.createUrl(ApiPath.ADMIN.USER_ADMIN.PATH)
        return this.requestService.requestGet(url, p)
    }
    public searchInSalon(salonId: number, params = {}) {
        const p = {
            orderBy: 'id|desc',
            ...params,
        }
        const url = this.requestService.createUrl(ApiPath.ADMIN.USER_ADMIN.PATH)
        return this.requestService.requestGet(url, p)
    }

    public createNew(params) {
        const url = this.requestService.createUrl(ApiPath.ADMIN.USER_ADMIN.PATH)
        return this.requestService.requestPost(url, params)
    }

    public updateSingleUser(userId: number, params) {
        const url = this.requestService.createUrl(ApiPath.ADMIN.USER_ADMIN.DETAIL.PATH, {
            userId: userId,
        })
        return this.requestService.requestPut(url, params)
    }

    public getDevicesOfUser(userId, filters) {
        const url = this.requestService.createUrl(ApiPath.ADMIN.USER_ADMIN.DETAIL.DEVICE.PATH, { userId: userId })
        return this.requestService.requestGet(url, filters)
    }
}
